import { createElement } from 'react';
import getDisplayName from 'react-display-name';
import omit from 'just-omit';
var omitProps = function omitProps() {
  for (var _len = arguments.length, propsToOmit = new Array(_len), _key = 0; _key < _len; _key++) {
    propsToOmit[_key] = arguments[_key];
  }
  return function (Target) {
    var OmitProps = function OmitProps(props) {
      return createElement(Target, omit(props, propsToOmit));
    };
    if (process.env.NODE_ENV !== 'production') {
      OmitProps.displayName = "omitProps(".concat(getDisplayName(Target), ")");
    }
    return OmitProps;
  };
};
export default omitProps;